import { useSelector } from "react-redux"
import { getUserProfile } from "@/reducers/userProfile"
import { AccessTokenClaims, CastedUserManager, userManager } from "./odUserManager"
import { User } from "oidc-client"
import { useMemo } from "react"

export const useIsLocalUserWithNoPhone = () => {
  const um = userManager as CastedUserManager
  const userProfile = useSelector(getUserProfile)
  
  const result = useMemo(() => {
    const user = User.fromStorageString(
      window.localStorage.getItem('oidc.'+um._userStoreKey) ?? '{}'
    )
    if (!user) { return true }
    let isLocalLogin = false
    try {
      const jwtAt = um._joseUtil.parseJwt<AccessTokenClaims>(user.access_token)
      isLocalLogin = jwtAt.payload.idp === 'local'
    } catch {
      isLocalLogin = true
    }
    
    return Boolean(isLocalLogin && !userProfile?.phone)
  }, [um, userProfile?.phone])

  return result
}